import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '../services/AuthService';
import { RegistryService } from '../services/RegistryService';
import { Dialog } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { NetworkService } from '../services/NetworkService';
import { Toast } from 'primeng/toast';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { filter, firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Dialog, Button, Toast, TranslocoPipe],
  template: `
    @if(langloaded()) {
      <p-toast [position]="this.auth.rtl() ? 'top-left': 'top-right'" />
      <router-outlet />
      <p-dialog
        (close)="net.showNetworkError.set(false)"
        header="Network Error"
        [modal]="true"
        [(visible)]="net.showNetworkError"
        [style]="{ width: '25rem' }">
        <h1 class="h-1">{{'Something wrong with network'|transloco}}</h1>
        <div class="flex justify-end gap-2">
          <p-button label="Ok" severity="secondary" (click)="net.showNetworkError.set(false)" />
        </div>
      </p-dialog>
    }
  `
})
export class App {
  public langloaded = signal(false)
  public t = inject(TranslocoService)
  public net = inject(NetworkService)
  public registry = inject(RegistryService)
  public auth = inject(AuthService)

  constructor() {
    console.log("App constructor")
    this.init().catch();
    document.documentElement.setAttribute('dir', localStorage.getItem('dir') || 'ltr');
    document.documentElement.setAttribute('lang', localStorage.getItem('lang') || 'en_us');
  }

  async init() {
    console.log("App init")

    const script = document.createElement('script');
    script.src = environment.services.schedule + '/widgets/assignments/index.js';
    script.async = true;
    script.crossOrigin = "anonymous";
    script.type = "module";
    document.body.appendChild(script);

    // 1. Wait for transloco to load the active language
    console.log("Waiting for transloco to load")
    try {
      await firstValueFrom(this.t.events$.pipe(
        filter(e => e.type === "translationLoadSuccess" && e.payload.langName === this.t.getActiveLang())
      ));
      console.log("Transloco loaded successfully")
    } catch (e) {
      console.warn('Transloco load timed out or failed, continuing...', e);
    }

    // 2. If logged in, load user and services (token validation happens via loadUser)
    console.log("Loading initial data")
    if (this.auth.isLoggedIn()) {
      try {
        await Promise.all([
          this.auth.loadUser(),
          this.registry.loadServices()
        ]);
        console.log("Initial data loaded successfully")
      } catch (error) {
        console.error('Initial data load failed:', error);
      }
    }

    this.langloaded.set(true);
  }
}
